<template>
    <section class="breadcrumb-section">
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item" v-if="!hideHome">
                        <router-link to="/">Home</router-link>
                    </li>
                    <li
                        v-for="(breadcrumb, index) in breadcrumbs"
                        :key="index"
                        class="breadcrumb-item"
                    >
                        <router-link
                            v-if="breadcrumb.url"
                            :to="breadcrumb.url"
                            >{{ breadcrumb.name }}</router-link
                        >
                        <span v-else> {{ breadcrumb.name }} </span>
                    </li>
                </ol>
            </nav>
        </div>
    </section>
</template>

<script>
/***
 * Usage
 * <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
 * @param breadcrumbs ARRAY
 * @param [{ name: 'name', url: 'url' }]
 */

export default {
    /* eslint-disable */
    name: "Breadcrumb",
    /* eslint-enable */
    props: ["hideHome", "breadcrumbs"],
    data() {
        return {
            isBusy: false
        };
    },
    computed: {},
    components: {},
    mounted() {},
    methods: {}
};
</script>
